import { tablemill } from "../tablemill_metal";
import { SIGraphForm } from "../view/si_graph_form";
import { TrendsScattergramForm } from "../view/trends_scattergram_form";
import { RelatedRecipesController } from "./related_recipes_controller";

class TrendsController {
  private siGraph: any;
  private scattergram: any;
  private relatedRecipes: RelatedRecipesController | null;

  constructor() {
    this.relatedRecipes = null;

    tablemill.onController("trends", () => {
      this.siGraph = new SIGraphForm();
      this.siGraph.initialize();
      this.siGraph.render();

      this.scattergram = new TrendsScattergramForm(
        { x: "KMR", y: "KSV" },
        this.siGraph.keyword,
        this.siGraph.targetDate,
      );
      this.scattergram.initializeScattergram();
      this.scattergram.render();

      this.relatedRecipes = new RelatedRecipesController();
      this.relatedRecipes.initialize();
      this.relatedRecipes.render();
    });
  }
}

export { TrendsController };
